<div
  #scrollArea
  class="filter-swiper-wrapper"
>

  <yu-chip
    class="selector-button"
    [selected]="hasValue"
    (click)="openModalSelector()"
  >
    <yu-icon weight="bold" name="funnel"></yu-icon>
  </yu-chip>

  @for (item of items; track item[itemsValueField]) {

    <yu-chip
      [selected]="item[itemsValueField] === value || (multiple && value.includes(item[itemsValueField]))"
      (click)="doActionItem(item[itemsValueField])"
    >
      {{ item[itemsLabelField] | translate }}
    </yu-chip>

  }

</div>
